// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8baadb18","732":"4c9fea59","977":"11896b93"}[chunkId] + ".chunk.js";
};